import React from 'react'
import customRequest from '../../../helpers/customRequest'
import { Link } from 'react-router-dom'
import ClipLoader from 'react-spinners/ClipLoader'

class Subscription extends React.Component
{
    state = {
        students: 0,
        loading: true
    }

    componentDidMount() {
        customRequest.get("/api/status")
        .then(({data}) =>
        {
            this.setState({loading: false, students: data.active})
        })
    }

    render()
    {
        var { students } = this.state
        return (
            <React.Fragment>
                <h3>Current Subscription:</h3>
                <div class = "form-horizontal">
                    <div class = "form-group row">
                        <label class = "col-6 control-label text-right"><span className = "float-right">Access</span></label>
                        <div class = "col-6">
                            {this.state.loading ?
                                <div class = "float-left">
                                    <ClipLoader
                                        margin={10}
                                        size={20}
                                        color={"#123abc"}
                                        loading={this.state.loading}/>
                                </div>
                            : 
                                
                                    <p class = "form-control-static text-left">{students} student{students > 1 ? "s" : ""} {students == 0 ? <span class = "glyphicon glyphicon-remove"></span> : ""}</p>
                            }
                        </div>
                    </div>
                </div>

                <div class = "row">
                    <div class = "col-sm-6">
                        <Link to = "/account/subscription/share" class = "btn btn-secondary btn-lg">Share Subscription</Link>
                    </div>
                    
                    <div class = "col-sm-6">
                        <Link to = "/account/subscription/share/manage" class = "btn btn-secondary btn-lg">Manage Sharing Settings</Link>
                    </div>
                </div>


                <hr class = "strong" />


                {/* <h3>Future Subscriptions:</h3>

                <div class = "form-horizontal">
                    <div class = "form-group row">
                        <label class = "col-6 control-label text-right">Last Subscription Expiration</label>
                        
                        <div class = "col-6">
                            <p class = "form-control-static text-left"><?php echo $accessExpiration; ?><?php echo $accessExpirationAlert; ?></p>
                        </div>
                    </div>
                </div> */}

                <div class = "row">
                    <div class = "col-sm-6 offset-sm-3">
                        <Link to = "/subscribe" class = "btn btn-secondary btn-lg">Renew Your Subscription</Link>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Subscription
